export enum DeliveryReceiptSorting {
    SUPPLIER = 'SUPPLIER',
    DELIVERY_DATE = 'DELIVERY_DATE',
    STATUS = 'STATUS',
}
